import * as Style from './style.js';
import contentFactory from './contentFactory.json';
import { Outlined } from '../../../assets/newIcons.js';
import { ArrowButton, ImageCover } from '../../../components/index.js';
import womanWithLaptop from '../../../assets/womenWithLaptop.png';
import womanWithLaptopMob from '../../../assets/womenWithLaptopMob.png';
import utils from '../../../helper/utils.js';
import { PALLETE } from '../../../configs/configs.js';

const { responsive } = utils;

const Intro = ({ simuleRef, introRef }) => {
  return (
    <ImageCover
      image={window.innerWidth > 450 ? womanWithLaptop : womanWithLaptopMob}
      height={responsive.choose(466)(612)}
      introRef={introRef}
    >
      <Style.FirstContent>
        <Style.BigTitle style={{
          marginBottom: 9,
          color: PALLETE.bluieshWhite,
          marginTop: 44,
        }}>
          <span>Investimentos</span> que <br />protegem o <span>futuro</span>
        </Style.BigTitle>
        {
/*           contentFactory[1].map((item, i) => {
            return (
              <div className="container" key={`tiny-text-1-${i}`}>
                <img
                  className="icon"
                  src={Outlined(item.icon)}
                  alt="Choose"
                />
                <span className="smaller-text">{item.text}</span>
              </div>
            );
          }) */
        }
        <ArrowButton
          label="Simule investimento"
          style={{ marginTop: 15 }}
          onClick={() => {
            responsive.scrollToContent(simuleRef);
          }}
        />
      </Style.FirstContent>
    </ImageCover>
  );
};

export default Intro;
